import axios from 'axios'

export default {

    async initCustomer(customerId) {
        return axios.post(`${process.env.VUE_APP_FIREBASE_FUNCTIONS_ROOT}/initCustomer`, { customerId })
    }

}